import colors from './color';
import font from './font';
import shadow from './shadow';

export default {
  color: colors,
  font: font,
  shadow: shadow,
};
